import * as PoolUploadRepository from './PoolUploadRepository.ts'
import * as OrderSubmissionRepository from './OrderSubmissionRepository.ts'

/** The wizard's own endpoints, handed to its epics as dependencies so tests swap them without module mocks. */
export const wizardRepositories = { PoolUploadRepository, OrderSubmissionRepository }

export type WizardRepositories = typeof wizardRepositories
